

import __layout_0 from '/home/runner/work/juno/juno/app/src/layouts/default.vue'
export const layouts = {
'404': () => import('/home/runner/work/juno/juno/app/src/layouts/404.vue'),
'default': __layout_0,
'home': () => import('/home/runner/work/juno/juno/app/src/layouts/home.vue'),
'operator': () => import('/home/runner/work/juno/juno/app/src/layouts/operator.vue'),
'operatorWithTabs': () => import('/home/runner/work/juno/juno/app/src/layouts/operatorWithTabs.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
